<template>
  <b-modal size="m" v-model="show" centered title="Filter"
  >
    <b-row class="mt-2">
      <b-col>
        <b-form-group label="Ort:" label-for="select_ort">
          <b-form-select class="black" id="select_ort" plain
                         v-model="selectedCity" :options="cities">
            <template v-slot:first>
              <b-form-select-option :value="null">-- Alle --
              </b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
        <b-form-group label="Ortsteil:" label-for="select_ortsteil">
          <b-form-select class="black" id="select_ortsteil" plain
                         v-model="selectedDistrict" :options="districts">
            <template v-slot:first>
              <b-form-select-option :value="null">-- Alle --
              </b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
        <b-form-group label="Maßnahme:" label-for="select_massnahme">
          <b-form-select class="black" id="select_massnahme" plain
                         v-model="selectedMeasure" :options="measures">
            <template v-slot:first>
              <b-form-select-option :value="null">-- Alle --
              </b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" variant="primary" @click="onReset">
        Zurücksetzen
      </b-button>
      <b-button size="md" variant="success" @click="onApply">
        Anwenden
      </b-button>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: "TaskFilterModal",
  props: {
    cities: {
      type: Array,
      default: () => []
    },
    districts: {
      type: Array,
      default: () => []
    },
    measures: {
      type: Array,
      default: () => []
    }
  },
  data: () => {
    return {
      selectedCity: null,
      selectedDistrict: null,
      selectedMeasure: null,
      show: false,
    }
  },
  methods: {
    getReturnData() {
      return {
        city: this.selectedCity,
        district: this.selectedDistrict,
        measure: this.selectedMeasure,
      };
    },
    onReset() {
      this.selectedCity = null;
      this.selectedDistrict = null;
      this.selectedMeasure = null;
      this.show = false;
      this.$emit("set-filter", this.getReturnData());
    },
    onApply() {
      this.show = false;
      this.$emit("set-filter", this.getReturnData());
    },
    onCancel() {
      this.show = false;
    },
    showDialog() {
      this.show = true;
    },
  }
}
</script>

<style scoped>

</style>
